import { motion, useReducedMotion } from "motion/react";
import { useMemo } from "react";

/** Confetti-lite: a dozen brand-colored dots that fall once. Skipped entirely under reduced motion. */
export function Confetti({ show }: { show: boolean }) {
  const reduce = useReducedMotion();
  const pieces = useMemo(
    () =>
      Array.from({ length: 16 }, (_, i) => ({
        id: i,
        x: (i / 16) * 100 + (i % 3) * 2,
        delay: (i % 5) * 0.08,
        color: i % 3 === 0 ? "var(--brand-primary)" : i % 3 === 1 ? "var(--brand-accent)" : "var(--brand-ink)",
      })),
    [],
  );
  if (!show || reduce) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-[65] overflow-hidden" aria-hidden>
      {pieces.map((p) => (
        <motion.span
          key={p.id}
          initial={{ y: -20, opacity: 1, rotate: 0 }}
          animate={{ y: "100vh", opacity: 0, rotate: 360 }}
          transition={{ duration: 1.6, delay: p.delay, ease: "easeIn" }}
          className="absolute top-0 block h-2.5 w-2.5 rounded-sm"
          style={{ left: `${p.x}%`, background: p.color }}
        />
      ))}
    </div>
  );
}
